import { Environments } from '@/config';
import { RENOWN_PRODUCTION } from './renown.production';
import { RENOWN_STAGING } from './renown.staging';

export const RENOWN = import.meta.env.MODE === Environments.PROD ? RENOWN_PRODUCTION : RENOWN_STAGING;
